import { ReactNode } from "react";
import { Navbar, NavbarBrand, NavbarContent, Link } from "@heroui/react";
import { BarChart3 } from "lucide-react";

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      <Navbar maxWidth="xl" className="border-b border-divider">
        <NavbarBrand>
          <div className="flex items-center gap-2">
            <BarChart3 className="w-6 h-6 text-primary" />
            <span className="font-bold text-lg">Deep42</span>
            <span className="text-default-400">|</span>
            <span className="text-sm text-default-500">
              Social Trading Leaderboard
            </span>
          </div>
        </NavbarBrand>
        <NavbarContent justify="end">
          <Link
            href="https://docs.cambrian.org"
            target="_blank"
            className="text-sm text-default-500 hover:text-primary"
          >
            API Docs
          </Link>
          <Link
            href="https://deep42.cambrian.network"
            target="_blank"
            className="text-sm text-default-500 hover:text-primary"
          >
            Deep42 API
          </Link>
        </NavbarContent>
      </Navbar>

      <main className="container mx-auto px-4 py-8 max-w-7xl">{children}</main>

      <footer className="border-t border-divider py-6 mt-12">
        <div className="container mx-auto px-4 max-w-7xl text-center text-sm text-default-400">
          <p>
            Powered by{" "}
            <Link
              href="https://cambrian.org"
              target="_blank"
              className="text-primary"
            >
              Cambrian
            </Link>{" "}
            &{" "}
            <Link
              href="https://deep42.cambrian.network"
              target="_blank"
              className="text-primary"
            >
              Deep42
            </Link>
          </p>
          <p className="mt-1">
            Real-time social trading intelligence from crypto Twitter
          </p>
        </div>
      </footer>
    </div>
  );
}
